// @ts-nocheck
import isArray from "lodash/isArray";
import { Children, ReactNode } from "react";

export default (children: ReactNode): ReactNode => {
    return Children.map(children, (x: any) => {
        const child = x?.props?.children;

        if (isArray(child)) {
            return !child.length || child.some((x: any) => x) ? x : null;
        }

        return x;
    });
};
